'use client';

import { useSyncExternalStore } from 'react';

/**
 * True while the viewport matches the media query; re-evaluated on change.
 *
 * A server render and its hydration both see false, so they agree; a page that
 * never ran on a server reads the real answer on its first render, so a phone
 * does not see the desktop layout flash first.
 */
export function useMediaQuery(query: string): boolean {
    return useSyncExternalStore(
        (onChange) => {
            const list = window.matchMedia(query);
            list.addEventListener('change', onChange);
            return () => list.removeEventListener('change', onChange);
        },
        () => window.matchMedia(query).matches,
        () => false,
    );
}
